import { all, put, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { REQUEST_FUNDING_SEARCH_OVERVIEW } from './types';

import { fundingSearchOverviewSuccess, fundingSearchOverviewFailure } from './reducer';

const logger = new Logger('Saga:Dashboard:FundingSearchOverview');

export function* getFundingSearchOverview() {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield authApiService.get(
      routerService.generate('api.dashboard.funding_search_kpi'),
    );
    logger.info('Got funding search overview data');
    yield put(fundingSearchOverviewSuccess(response.data));
  } catch (error) {
    logger.error(error);
    yield put(fundingSearchOverviewFailure(error));
  }
}

export default function* userSaga() {
  return yield all([takeLatest(REQUEST_FUNDING_SEARCH_OVERVIEW, getFundingSearchOverview)]);
}
